import { AutogenLayoutRenditionLogixProfiles } from "./autogen/AutogenLayoutRenditionLogixProfiles";
import { ClickEvent, DropdownItem, Textbox, DataSourceExecutionEvent, DataSourceMode } from "@mcleod/components";
import { ImgLic } from "./ImgLic";

let renlgxLicensed: boolean = false;

export class RenditionLogixProfiles extends AutogenLayoutRenditionLogixProfiles {

    override async onLoad() {
        //this.sourceDpsqlh.search();     //get all fields
        //this.sourceDxmwpgs.search( { dxmw_app_name: "wdp-renlgx" } );
        //this.sourceDxmwpgs.search( { dxmw_app_name: "wdp-wfidx" } );
        //this.SetDropDowns();

        renlgxLicensed = await ImgLic.renlgxLicensed();

        this.textboxLgxpUrl.visible = renlgxLicensed;
        this.textboxLgxpLogin.visible = renlgxLicensed;
        this.textboxLgxpPwd.visible = renlgxLicensed;
        this.textboxLgxpFname.visible = renlgxLicensed;
        this.textboxLgxpFormat.visible = renlgxLicensed;
        this.textboxLgxpSepinv.visible = renlgxLicensed;
        this.textboxLgxpColor.visible = renlgxLicensed;
        this.textboxLgxpCombinetype.visible = renlgxLicensed;
    }

    SetDropDowns()
    {
        // const items: DropdownItem[] = [];
        // //items.push({ caption: "Yes", value: "Y" });
        // //items.push({ caption: "No", value: "N" });
        // items.push(new DropdownItem( "Y", "Yes" ));
        // items.push(new DropdownItem( "N", "No" ));
        // //Combine Folders
        // this.textboxFtppCombine.items = items;
        // //Color
        // this.textboxFtppColor.items = items;
        // //Export File
        // this.textboxFtppFileexport.items = items;
        // //Format
        // const items2: DropdownItem[] = [];
        // //items2.push({ caption: "Tif", value: "T" });
        // //items2.push({ caption: "Pdf", value: "P" });
        // items2.push(new DropdownItem( "T", "Tif" ));
        // items2.push(new DropdownItem( "P", "Pdf" ));
        // this.textboxFtppFormat.items = items2;
        // //Export Resolution
        // const items3: DropdownItem[] = [];
        // //items3.push({ caption: "Folder", value: "F" });
        // //items3.push({ caption: "Image", value: "I" });
        // items3.push(new DropdownItem( "F", "Folder" ));
        // items3.push(new DropdownItem( "I", "Image" ));
        // this.textboxFtppExportres.items = items3;
        // //Unit
        // const items4: DropdownItem[] = [];
        // //items4.push({ caption: "Single Folder", value: "S" });
        // //items4.push({ caption: "Multiple Folders", value: "M" });
        // //items4.push({ caption: "All Folders", value: "A" });
        // items4.push(new DropdownItem( "S", "Single Folder" ));
        // items4.push(new DropdownItem( "M", "Multiple Folders" ));
        // items4.push(new DropdownItem( "A", "All Folders" ));
        // this.textboxFtppUnit.items = items4;
        // //Packing
        // const items5: DropdownItem[] = [];
        // //items5.push({ caption: "None", value: "N" });
        // //items5.push({ caption: "Tar", value: "T" });
        // //items5.push({ caption: "Zip", value: "Z" });
        // items5.push(new DropdownItem( "N", "None" ));
        // items5.push(new DropdownItem( "T", "Tar" ));
        // items5.push(new DropdownItem( "Z", "Zip" ));
        // this.textboxFtppPacking.items = items5;
    }


/** This is an event handler for the afterExecution event of sourceDpsqlh. */
  sourceDpsqlhAfterExecution(event: DataSourceExecutionEvent) {
    // const rows: any[] = event.dataSource.data;
    // const items: DropdownItem[] = [];
    // let idx = -1;
    // for (const row of rows) {
    //     //console.log("Row: ", row );
    //     items.push(new DropdownItem( row._data.sqlh_grpid.toString(), row._data.sqlh_desc ));
    //     if( this.textboxLgxpSqlgrpid.text == row._data.lgxp_sqlgrpid )
    //         idx = items.length - 1;
    // }
    // this.textboxLgxpSqlgrpid.items = items;
    // if( idx != -1 )
    //     this.textboxLgxpSqlgrpid.selectedItem = items[idx];
  }

/** This is an event handler for the afterExecution event of sourceDxmwpgs. */
  async sourceDxmwpgsAfterExecution(event: DataSourceExecutionEvent) {
    const rows: any[] = event.dataSource.data;
    let mid=-1;
    let mname="";
    for (const row of rows)
    {
        mname = "wdp-renlgx";
        if( row._data.dxmw_app_name == mname )
        {
            mid = row._data.dxmw_master_id;
            await this.sourceDxmasterp.search( { dxm_id: mid } );
            const rows: any[] = this.sourceDxmasterp.data;
            mname = rows[0]._data.dxm_name;
            break;
        }
    }
    if( mid >= 0 )
    {
        await this.sourceDxproject.search( { dxp_master_id: mid, dxp_status: "A" } );
        if( this.sourceDxproject.data.length == 0 )
            await this.sourceDxproject.search( { dxp_master_id: mid } );
        if( this.sourceDxproject.data.length == 0 )
            return;
        const rows: any[] = this.sourceDxproject.data;
        const pid = rows[0]._data.dxp_proj_id;
        const items: DropdownItem[] = [];
        if( pid === undefined )
            return;
        let preidx = -1;
        if( pid >= 0 )
        {
            await this.sourceDxfunction.search( { dxf_proj_id: pid } );
            const rows: any[] = this.sourceDxfunction.data;
            for (const row of rows) {
                items.push(new DropdownItem( row._data.dxf_func_id, row._data.dxf_name ));
                if( this.textboxLgxpPrefid.text == row._data.dxf_func_id )
                    preidx = items.length - 1;
            }
        }
        this.textboxLgxpPrefid.items = items;
        if( preidx != -1 )
            this.textboxLgxpPrefid.selectedItem = items[preidx];
        const desc = mid + " - " + mname;
        this.textboxLgxpMid.text = mid.toString(); //desc;
        // if( this.sourceRenditionLogixProfiles.mode ==  DataSourceMode.SEARCH )
        // {
        //     this.textboxLgxpMid.enabled = true;
        // }
    }
  }
}
